import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {removeNonDigits} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";
import * as AdminActions from "../../../../actions/admin";

class GeneralPigeons extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            listType: 0,
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            pigeonhole: '',
            onlyActive: false,
            hideUnsigned: false,
        });
    }

    componentDidMount() {
        if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
    }

    fields = [];
    render() {
        return <div className="general-members">
            <label className={'header'}>Filtréring (valgfrit)</label>
            <div className={'upper-container'}>
                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div className={'attribute-row'}>
                    <div className={'attribute-pair'}>
                        <label>Fra sektion</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="fromSection"
                            id="fromSection"
                            maxLength="2"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                            value={this.state.fromSection}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            ref={instance => { this.fields[0] = instance; }}
                        />
                    </div>
                    <div className={'attribute-pair'}>
                        <label>Til sektion</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="toSection"
                            id="toSection"
                            maxLength="2"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                            value={this.state.toSection}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            ref={instance => { this.fields[1] = instance; }}
                        />
                    </div>
                </div> : null}
                {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <div className={'attribute-row'}>
                    <div className={'attribute-pair'}>
                        <label>Fra forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="fromClub"
                            id="fromClub"
                            maxLength="3"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]}
                            value={this.state.fromClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[2].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.fromClub)) this.setState({fromClub: this.state.fromClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[2] = instance; }}
                        />
                    </div>
                    <div className={'attribute-pair'}>
                        <label>Til forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="toClub"
                            id="toClub"
                            maxLength="3"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]}
                            value={this.state.toClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[3].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.toClub)) this.setState({toClub: this.state.toClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[3] = instance; }}
                        />
                    </div>
                </div>}
                {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? <div className={'attribute-row'}>
                    <div className={'attribute-pair'}>
                        <label>Slag</label>
                    </div>
                    <div>
                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p"
                                          name="pigeonhole" id="pigeonhole" value={this.state.pigeonhole} options={
                                              this.props.admin.pigeonHoles ? this.props.admin.pigeonHoles.filter(p => p.Foreningsnr === this.props.auth.currentEntity).sort((p1, p2) => p1.Slagnr < p2.Slagnr ? -1 : (p1.Slagnr > p2.Slagnr ? 1 : 0)).map(pigeonHole => (
                                                  {key: pigeonHole.Slagnr, value: pigeonHole.Slagnr + (pigeonHole.Slagnavn === null ? '' : ' - ' + pigeonHole.Slagnavn)}
                                              )).toArray() : []
                                          }
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={this.onStandardFieldChange}
                                          ref={instance => { this.fields[4] = instance; }}
                        />
                    </div>
                </div> : null}
                <div className={'attribute-row'}>
                    <span className={'attribute-pair no-justify'}>
                        <input type="checkbox" id="onlyActive" name="onlyActive" checked={this.state.onlyActive} onClick={() => this.setState({onlyActive: !this.state.onlyActive})}/>
                        <label htmlFor="onlyActive">Vis kun aktive</label>
                    </span>
                    {/*<span className={'attribute-pair no-justify'}>
                        <input type="checkbox" id="hideUnsigned" name="hideUnsigned" checked={this.state.hideUnsigned} onClick={() => this.setState({hideUnsigned: !this.state.hideUnsigned})}/>
                        <label htmlFor="hideUnsigned">Skjul udgåede</label>
                    </span>*/}
                </div>
                <div className={'report-types'}>
                    <div className={'radio-buttons-container column-gap'}>
                        <div className="radio-button-container">
                            <input id="reporting-list" type="radio" checked={this.state.listType === 0} onChange={() => this.setState({listType: 0})}/>
                            <label htmlFor="reporting-list">Bestandliste</label>
                        </div>
                        <div className="radio-button-container">
                            <input id="vaccination" type="radio" checked={this.state.listType === 1} onChange={() => this.setState({listType: 1})}/>
                            <label htmlFor="vaccination">Vaccination</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onDigitInputFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: removeNonDigits(e.target.value)});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        if (this.state.fromSection !== '' && this.state.toSection !== '' && this.state.fromSection > this.state.toSection) errors.push('Fra sektion kan ikke være større end Til sektion.');
        if (this.state.fromClub    !== '' && this.state.toClub    !== '' && this.state.fromClub    > this.state.toClub)    errors.push('Fra forening kan ikke være større end Til forening.');

        let options = {
            listType:    this.state.listType,
            fromSection: this.state.fromSection === '' ? null : this.state.fromSection,
            toSection:   this.state.toSection   === '' ? null : this.state.toSection  ,
            fromClub:    this.state.fromClub    === '' ? null : this.state.fromClub   ,
            toClub:      this.state.toClub      === '' ? null : this.state.toClub     ,
            pigeonhole:  this.state.pigeonhole  === '' ? null : this.state.pigeonhole ,
            onlyActive:  this.state.onlyActive,
            hideUnsigned:this.state.hideUnsigned
        };

        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        pigeonHoles: state.admin.pigeonHoles,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(GeneralPigeons);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/GeneralPigeons.js